import { makeModuleInstance, warningBanner } from '@zg-rentals/util';
import pino from 'pino';

export type Logger = pino.Logger;

export type LoggerOptions = pino.LoggerOptions & {
  logPath?: string;
};

export const createLogger = pino;

const { get, set: setGlobalLogger } = makeModuleInstance<Logger | undefined>(undefined);

export function getGlobalLogger(name?: string) {
  return name ? get()?.child({ name }) : get();
}

export { setGlobalLogger, warningBanner };
